export type { Theme } from './themes'
export type { ModifyThemeFunctionType } from './getTheme'

export { theme } from './main'
export { getTheme } from './getTheme'
export { NormalizeStyles } from './normalize'
export { ThemeProviders } from './ThemeProviders'
